<dialog-header label='{{title}}' [dialogRef]='dialogRef' [object]='this'></dialog-header>
<mat-dialog-content>
  <ng-container #bodyContainer></ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button *ngIf="okButtonShown" (click)="onOk()">{{'ACTIONS.OK' | translate}}</button>
  <button mat-stroked-button (click)="onClose()">{{'ACTIONS.CLOSE' | translate}}</button>
</mat-dialog-actions>
